<template>
  <div>
    <!--面包蟹-->
    <div class="container" style="height: 40px; line-height: 40px; color: #999">
      <i class="iconfont icon-ziyuan"></i>&nbsp;
      <span class="font_link_fw"><router-link :to="{name: 'home'}">首页</router-link></span> &nbsp;&nbsp;>&nbsp;&nbsp;
      <span @click="zyfuwu()" class="productHref">专业服务</span> &nbsp;&nbsp;>&nbsp;&nbsp;
      <span style="color: #666"><b>{{title}}</b></span>
      <div style="position:relative;z-index: 1; left: 0px; top: 0px;" class="menu_list_r" v-show="fuwu" @mouseout="moveOut" @mouseover="moveOver">
        <div  class="list_name_r" style="background-color: #679dcc; color: #fff"><b>专业服务</b></div>
        <router-link to="/serviceList?title=检维修服务"><div class="list_name_r">检维修服务</div></router-link>
        <router-link to="/serviceList?title=培训服务"><div class="list_name_r">培训服务</div></router-link>
        <router-link to="/serviceList?title=咨询设计服务"><div class="list_name_r">咨询设计服务</div></router-link>
        <router-link to="/serviceList?title=供应链代采服务"><div class="list_name_r">供应链代采服务</div></router-link>
      </div>
    </div>

    <!--banner-->
    <!--<div class="block banner" style="height: 450px;"></div>-->
    <!--列表-->
    <div class="container topMargin" style="text-align: left">
      <el-col class="planListbox" v-for="(plan, index) in dataList" :key="index" style="width: 380px; margin-left: 21px; margin-right: 21px; float: left">
        <el-col :span="24"><img style="width: 380px; height: 276px" :src="plan.imgUrl" :onerror="defaultImg" /></el-col>
        <el-col :span="24">
          <el-col class="planListTitle" style="padding-left: 10px">{{plan.title}}</el-col>
          <el-col class="planListCon">
            {{plan.content}}
          </el-col>
          <!--<el-col>-->
            <!--<router-link :to="{name:'content', query:{id:plan.childId}}"><el-button>查看详细服务</el-button></router-link>-->
          <!--</el-col>-->
        </el-col>
      </el-col>
    </div>
  </div>
</template>

<script>
import dataSource from '@/data/service'
export default {
  name: 'serviceList',
  data () {
    return {
      dataSource,
      fuwu: false,
      dataList: [],
      defaultImg: require('@/assets/img/zwtp.png'),
      timer1: ''
    }
  },
  methods: {
    zyfuwu () {
      this.fuwu = true
    },
    moveOut () {
      this.timer1 = setTimeout(_ => {
        this.fuwu = false
      }, 1000)
    },
    moveOver () {
      clearTimeout(this.timer1)
    }
  },
  computed: {
    title () {
      return this.$route.query.title
    }
  },
  watch: {
    title (newVal) {
      this.dataList = dataSource[this.title]
      // console.log('dataList', this.dataList)
    }
  },
  created () {
    this.dataList = dataSource[this.title]
    // console.log('dataList', this.dataList)
  }
}
</script>

<style scoped>
  .banner {
    background: url("/static/img/bannerplan.jpg") no-repeat top center;
  }

  .planListbox {
    margin-top: 30px;
    margin-bottom: 30px;
    background: #f7f7f7
  }

  .planListTitle {
    font-size: 20px;
    margin: 10px 0px 0px 0px;
  }

  .planListCon {
    font-size: 14px;
    line-height: 25px;
    color: #999;
    padding: 10px;
    height: 200px;
  }

  .el-button--medium {
    padding: 14px 40px;
    font-size: 14px;
    border-radius: 30px;
    margin: 10px 20px 0px 20px;
    background: #3195c5;
    color: #fff;
  }
  .topMargin{margin-top: 30px}
  .font_link_fw a{color: #666}
  .font_link_fw a:hover{color: #666}
  .menu_list_r {
    position: absolute;
    right: 0px;
    top: 42px;
    width: 150px;
    height: auto;
    z-index: 1;;
    background-color: #f0f0f0;
    display: block;
    font-size: 14px;
    border-bottom: 2px #679dcc solid;

  }
  .list_name_r {
    width: 100%; height: 35px; background-color: #f7f7f7; line-height: 35px; padding-left: 10px;border-bottom: 1px #ccc solid;color: #666;
  }
  .list_name_r:hover {
    width: 100%; height: 35px; background-color: #f0f0f0; line-height: 35px; padding-left: 10px;border-bottom: 1px #ccc solid;color: #666;
  }
.productHref {
  cursor: pointer;
  color: #409EFF;
}
</style>
